// lib/store/slices/projectFileTreeSlice.js
import { getProjectFileTree } from "../../api/getProjectFileTree";

export const createProjectSlice = (set, get) => ({
  projectTree: [],
  projectLoading: false,
  projectError: null,

  setProjectTree: (tree) =>
    set({ projectTree: Array.isArray(tree) ? [...tree] : [] }),
  clearProjectTree: () => set({ projectTree: [] }),

  // ✅ (변경) 프로젝트 ID를 추가로 받아서 전달
  fetchProjectTree: async (userId, projectId) => {
    set({ projectLoading: true, projectError: null });
    const res = await getProjectFileTree(userId, projectId);
    if (!res.success) {
      set({
        projectTree: [],
        projectLoading: false,
        projectError: res.message,
      });
      return { success: res.success, message: res.message };
    }
    set({
      projectTree: Array.isArray(res.data) ? [...res.data] : [],
      projectLoading: false,
      projectError: null,
    });
    return { success: res.success, message: res.message };
  },
});
